import React, { memo, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { Box, Typography } from '@material-ui/core'

import { CookieItem } from '../'
import { useStyles } from './styles'

const CookieCategoryCollapse = () => {
  const PAGE_SIZE = 15
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
  const { control } = useFormContext()
  const { fields: cookies } = useFieldArray({
    control,
    name: 'cookies',
  })
  const classes = useStyles()

  const handleLoadMore = (total) => {
    setVisibleCount((prev) => Math.min(prev + PAGE_SIZE, total))
  }

  return (
    <Box className={classes.container} id="scrollable-cookies-list">
      <InfiniteScroll
        dataLength={Math.min(visibleCount, cookies.length)}
        next={() => handleLoadMore(cookies.length)}
        hasMore={visibleCount < cookies.length}
        loader={<Typography align="center">Carregando...</Typography>}
        scrollableTarget="scrollable-cookies-list"
        style={{ overflow: 'visible' }}
      >
        <Box className={classes.cookiesContainer}>
          {cookies.slice(0, visibleCount).map((cookie, index) => (
            <CookieItem
              key={cookie.id || index}
              cookie={cookie}
              cookieIndex={index}
            />
          ))}
        </Box>
      </InfiniteScroll>
    </Box>
  )
}

export default memo(CookieCategoryCollapse)
